import { LottieKey } from "Types";

export const APP_DOWNLOAD_URL = {
  ANDROID: "https://play.google.com/store/apps/details?id=com.aircrex",
  IOS: "https://apps.apple.com/au/app/hello-clever/id1499192377",
};

export const SOCIAL_URL = {
  FACEBOOK: "https://www.facebook.com/helloclever.co",
  X: "https://x.com/hello_clever",
  INSTAGRAM: "https://www.instagram.com/helloclever.co/",
  LINKEDIN: "https://www.linkedin.com/company/helloclever",
  TIKTOK: "https://www.tiktok.com/@helloclever.co",
  YOUTUBE: "https://www.youtube.com/@hello_clever",
};

export const ADDRESS = "https://maps.app.goo.gl/xLUQ9d6qrBuuYp4a7";

export const MERCHANT_SIGN_UP = "https://merchant.helloclever.co";
export const OUR_PARTNERS =
  "https://www.notion.so/helloclever/Our-Partners-ace5b327b05e4c09b77dfb2b5dc9a475";
export const CAREERS =
  "https://helloclever.notion.site/Careers-Hello-Clever-119c8c68c1c54eb5b858202ef8a1cccf";
export const FAQS = "https://faqs.helloclever.co/en";
export const DEVELOPER_PORTAL = "https://docs.helloclever.co";
export const DEVELOPER_API_REF = "https://docs.helloclever.co/api-reference/";
export const DEMO_FORM =
  "https://share.hsforms.com/11wjC2b6zSRW_QpMl7k3njw4obho";

export const MERCHANT_SUPPORT =
  "https://support.helloclever.co/merchant-knowledge-base";

export const CONSUMER_SUPPORT =
  "https://support.helloclever.co/consumer-knowledge-base/faqs";

export const LAUNTEL_VIDEO_URL = "https://youtu.be/0HXyyY-tQGw";
export const CAKE_CREATION_URL =
  "https://youtu.be/i8e0jF5JIs4?si=9H-HmmtoL8MIXL89";

export const CLEVER_2023_REVIEW_BLOG_SLUG =
  "our-2023-wraps-a-year-of-innovation-success-and-exciting-new-features";

export const LOTTIE_URLS: Record<LottieKey, string> = {
  ALTERNATIVE: "/Assets/Lotties/alternative.json",
  AUTHORISATION_REQUEST: "/Assets/Lotties/authorisation_request.json",
  BUY_TO_EARN: "/Assets/Lotties/buy_to_earn_tab.json",
  CARD_TAB: "/Assets/Lotties/card_tab.json",
  CASHBACK: "/Assets/Lotties/cashback.json",
  DEVELOP_TEAM: "/Assets/Lotties/develop_team.json",
  FAQ: "/Assets/Lotties/faq.json",
  FIND_US_ONE: "/Assets/Lotties/find_us_one.json",
  FIND_US_TWO: "/Assets/Lotties/find_us_two.json",
  INCREASE_BASKET: "/Assets/Lotties/increase_basket.json",
  INDUSTRIES_TELCO: "/Assets/Lotties/industries_telco.json",
  INSTANT_CUSTOMER: "/Assets/Lotties/instant_customers.json",
  MARKETING_ASSETS: "/Assets/Lotties/marketing_assets.json",
  PAY_WITH_PAYTO: "/Assets/Lotties/pay_with_payto.json",
  PAYID_TAB: "/Assets/Lotties/payid_tab.json",
  PAYTO_INSTANT: "/Assets/Lotties/payto_instant_customer.json",
  PAYTO_TAB: "/Assets/Lotties/payto_tab.json",
  REACH_NEW_CUSTOMER: "/Assets/Lotties/reach_new_customer.json",
  REDUCE_FRAUD: "/Assets/Lotties/reduce_fraud.json",
  REDUCE_CART: "/Assets/Lotties/reduce_cart.json",
  REFER_FRIEND: "/Assets/Lotties/refer_friend.json",
  SUBSCRIBE_EMAIL: "/Assets/Lotties/subscribe_email.json",
  WORK_ECOMMERCE: "/Assets/Lotties/we_work_ecommerce.json",
  XERO_BANNER: "/Assets/Lotties/xero_banner.json",
};

export const TCFILE: string = "/Assets/Docs/T&Cs.pdf";

export const DEMO_PAGE_URL =
  process.env.NEXT_PUBLIC_ENVIRONMENT === "PRODUCTION"
    ? "https://cleverhub.co/:slug"
    : "https://rc.cleverhub.co/:slug";
